(function () {
  const algolia = window.algolia;
  if (!algolia || !algolia.enabled) return;

  // Every Insights event must carry an objectID that exists in the products
  // index. The Algolia Shopify app indexes at VARIANT level (objectID = variant
  // ID, product ID lives in `id`), so all events below send variant IDs.
  // Event vocabulary (keep in sync with predictive-search.js and
  // src/assets/js/algolia/index.js):
  //   "Product Viewed", "Product Clicked from Listing",
  //   "Product Clicked from Search", "Search Results Viewed".
  // Add-to-cart and purchase conversions are sent by the Algolia web pixel,
  // not the theme. Insights init, userToken and consent live in the
  // assets/algolia.js bundle (window.algolia).

  const aa = algolia.aa;
  const productsIndex = algolia.config.productsIndex;
  let lastViewedObjectID = null;

  function log() {
    algolia.log.apply(null, ["[Algolia]"].concat([].slice.call(arguments)));
  }

  function sendPdpView(objectID) {
    if (!objectID) return;
    const id = String(objectID);
    if (id === lastViewedObjectID) return;
    lastViewedObjectID = id;

    log("viewedObjectIDs (PDP)", id);
    aa("viewedObjectIDs", {
      eventName: "Product Viewed",
      index: productsIndex,
      objectIDs: [id],
    });
  }

  function trackPdpView() {
    const productInfo = document.querySelector("product-info[data-algolia-object-id]");
    if (!productInfo) return;

    sendPdpView(productInfo.dataset.algoliaObjectId);

    // Re-send when the customer picks another variant (size). variant-selects.js
    // only dispatches this with a numeric variant id.
    document.addEventListener("variantChange", (event) => {
      const variantId = event.detail?.variantId;
      if (variantId && !isNaN(variantId)) sendPdpView(variantId);
    });
  }

  function onListingClick(event) {
    const link = event.target.closest("a.product");
    if (!link) return;

    if (link.closest("#predictive-search-results-products-list")) return;

    const cell = link.closest("[data-algolia-object-id][data-algolia-position]");
    if (!cell) return;

    const objectID = cell.dataset.algoliaObjectId;
    if (!objectID) return;

    // ready is normally already settled; the event goes out via sendBeacon
    // so the navigation that follows doesn't cancel it.
    algolia.ready.then(() => {
      log("clickedObjectIDs (listing)", objectID);
      aa("clickedObjectIDs", {
        eventName: "Product Clicked from Listing",
        index: productsIndex,
        objectIDs: [String(objectID)],
      });
    });
  }

  function bootstrap() {
    document.addEventListener("click", onListingClick);
    // Wait for the consent decision so events carry the same userToken as the
    // search queries.
    algolia.ready.then(trackPdpView);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootstrap);
  } else {
    bootstrap();
  }
})();
